<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="0">
              <a-collapse-panel key="0">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="searchDate"
                    :format="getDefaultDateFormat"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select
                    placeholder="Ex: Other ... "
                    v-model="kategori"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getCategoryPI"
                      :key="item.value"
                      :value="item.value"
                      >{{ item.text }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="matauang">Currency</label>
                  <a-select
                    placeholder="Ex. IDR ..."
                    v-model="matauang"
                    class="width-full"
                    initialValue
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getAllMataUang"
                      :key="item.code"
                      :value="item.code"
                      >{{ item.code }} - {{ item.currency }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="PP List"
        createLink="createPP"
        manifestLink="manifestPp"
        editLink="editPp"
        :dataList="searching"
        :estimasi="true"
        :isTransactional="true"
        :allowcancel="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
export default {
  name: "listPP",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      basedList: [],
      kategori: undefined,
      searchDate: [],
      search: "",
      status: undefined,
      matauang: undefined,
    };
  },
  created() {
    this.$store.dispatch("FETCH_ALL_MATA_UANG");
    this.fetchData();
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getKategori",
      "getDefaultDateFormat",
      "getAllMataUang",
      "getCategoryPI",
    ]),
    searching() {
      var self = this;
      let output = this.dataList;

      if (this.search) {
        output = output.filter(
          (obj) =>
            obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
      
      if (this.searchDate && this.searchDate.length > 0) {
        let startDt = moment(this.searchDate[0]).format(this.getDefaultDateFormat);
        let endDt = moment(this.searchDate[1]).format(this.getDefaultDateFormat);

        output = output.filter(
          (obj) =>
            obj.tgl_buat &&
            moment(obj.tgl_buat).format(this.getDefaultDateFormat) >= startDt &&
            moment(obj.tgl_buat).format(this.getDefaultDateFormat) <= endDt
        );
      }

      if (this.kategori) {
        output = output.filter((item) => {
          return item.used_for == self.kategori;
        });
      }

      if (this.matauang) {
        output = output.filter((item) => {
          return item.mata_uang === self.matauang;
        });
      }

      if (this.status) {
        if (this.status=="closed"){
          output = output.filter(
            (obj) =>
              obj.closeStatus && obj.closeStatus.toLowerCase().indexOf("close") >= 0
          );
        } else if(this.status=="cancelled"){
          output = output.filter(
            (obj) =>
              obj.cancelStatus && obj.cancelStatus.toLowerCase().indexOf("canceled") >= 0
          );
        }else{
          output = output.filter(
            (obj) =>
              obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0 &&
              !(obj.closeStatus && obj.closeStatus.toLowerCase().indexOf("close") >= 0) &&
              !(obj.cancelStatus && obj.cancelStatus.toLowerCase().indexOf("canceled") >= 0)
          );
        }
      }

      return output;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "pp",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.basedList = response.data.data;

          response.data.data.forEach((data) => {
            this.dataList.push({
              islistPPrevised: !((data.cancel_sts== 1 || data.close_sts=="1") || data.status=="Rejected") && !(data.ispibkkuploaded && data.ispibkkuploaded=='1'),
              title: data.no_pp,
              subtitle: { deskripsi: data.deskripsi },
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              subdesc: [
                [
                  {
                    label: "Estimated Price",
                    value: this.formatCurrency(
                      data.mata_uang,
                      data.estimated_value
                    ),
                  },
                ],
                [
                  {
                    label: "Total Usage",
                    value: this.formatCurrency(
                      data.mata_uang,
                      data.total_pemakaian
                    ),
                  },
                ],
                [
                  {
                    label: "Remaining Balance",
                    value: this.formatCurrency(data.mata_uang, data.sisa_saldo),
                  },
                ],
              ],
              status: data.status,
              id: data.id_pp,
              estimated_value: data.estimated_value,
              mata_uang: data.mata_uang,
              closeStatus: data.close_sts=="1" ? "Close" : "",
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == "1" 
                  ? "Canceled"
                  : null
                : null,
              canceled_Status: data.canceled_status
                ? data.canceled_status == "1"
                  ? "Canceled"
                  : null
                : null, 
              tgl_buat: data.tgl_buat,
              used_for : data.used_for,
              searchQ:
                data.no_pp +
                " " +
                data.deskripsi +
                " " +
                data.estimated_value +
                " " +
                data.total_pemakaian +
                " " +
                data.sisa_saldo,
              status_direktorat: {
                direktorat: data.direktorat,
                status: data.status_keuangan
              }
            });
          });

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "pp",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.fetchData();
          this.searching;
          this.$router.go(0);

        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>

<style>
</style>